import React from "react";
import styled from "styled-components";

const InputSearch = ({  setQuery, placeholder }) => {

    return(
        <Label>
            <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#868686">
                <path d="M0 0h24v24H0V0z" fill="none"/>
                <path
                    d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"/>
            </svg>
            <Input
                type="text"
                placeholder={placeholder}
                onChange={event => {
                    setQuery(event.target.value)
                }}
            />
        </Label>
    )
}
const Label = styled.label`
  display: flex;
  flex-direction: row;
  align-items: center;
  background-color: rgba(166, 172, 181, 0.6);
  border-radius: 15px;
  transition: transform 0.5s ease-out;

  svg {
    margin-right: 1em;
    fill: var(--color-white);
  }

  @media (min-width: 768px) {
    width: 15rem;
    height: 2em;
    padding: 1em;
    &:hover{
      cursor: text;
      svg{
        display: none;
      }
    }
  }
`

const Input = styled.input`
  border: none;
  font-size: 0.7em;
  color: rgba(33, 37, 41, 1);
  background-color: transparent;

  &:focus {
    outline: none;
  }
`

export default InputSearch